const types = {
  SET_CREDIT: "SET_CREDIT",
  SET_LAST_CREDIT: "SET_LAST_CREDIT",
  SET_SOLICITATION: "SET_SOLICITATION",
  SET_BASIC_DATA: "SET_BASIC_DATA",
  SET_EDUCATIONAL_LEVEL: "SET_EDUCATIONAL_LEVEL",
  SET_BASIC_DATA_MARITAL_STATUS: "SET_BASIC_DATA_MARITAL_STATUS",
  SET_CREDIT_LINE: "SET_CREDIT_LINE",
  SET_DEFAULT_INPUT: "SET_DEFAULT_INPUT",
  SET_DEFAULT_CREDIT: "SET_DEFAULT_CREDIT",
  SET_CREDIT_CHECKBOX: "SET_CREDIT_CHECKBOX",
  SET_FIELDS: "SET_FIELDS",
  ADD_FIELD: "ADD_FIELD",
  SET_CREDIT_DATA: "SET_CREDIT_DATA",
  SET_SHOW_ENTIDAD_BY_ID: "SET_SHOW_ENTIDAD_BY_ID",
  SET_COMPLEMENT_DATA_ACTIVITIE: "SET_COMPLEMENT_DATA_ACTIVITIE",
  SET_PAYMENT_BILL: "SET_PAYMENT_BILL",
  // SET_SELECTED_STATE: "SET_SELECTED_STATE",
  // SET_SELECTED_CITY: "SET_SELECTED_CITY",
  SET_WORK_DATA_DOCUMENT_TYPE: "SET_WORK_DATA_DOCUMENT_TYPE",
  SET_WORK_CERTIFICATION: "SET_WORK_CERTIFICATION",
  REMOVE_WORK_CERTIFICATION_FILE: "REMOVE_WORK_CERTIFICATION_FILE",
  SET_WORK_DATA: "SET_WORK_DATA",
  SET_BRANCH: "SET_BRANCH",
  SET_COMPLEMENT_DATA_IDENTIFICATION_TYPE: "SET_COMPLEMENT_DATA_IDENTIFICATION_TYPE",
  SET_SEGMENT: "SET_SEGMENT",
  SET_COMPLEMENT_DATA: "SET_COMPLEMENT_DATA",
  SET_ADITIONAL_DATA_SELECTED_STATE: "SET_ADITIONAL_DATA_SELECTED_STATE",
  SET_ADITIONAL_DATA_SELECTED_CITY: "SET_ADITIONAL_DATA_SELECTED_CITY",
  SET_SELECTED_EXTRA_STATE: "SET_SELECTED_EXTRA_STATE",
  SET_SELECTED_EXTRA_CITY: "SET_SELECTED_EXTRA_CITY",
  SET_ADITIONAL_DATA: "SET_ADITIONAL_DATA",
  SET_EXTRACT: "SET_EXTRACT",
  SET_OWN_VEHICLE: "SET_OWN_VEHICLE",
  SET_CORRESPONDENCE: "SET_CORRESPONDENCE",
  SET_COMPLEMENT_DATA_SELECTED_STATE: "SET_COMPLEMENT_DATA_SELECTED_STATE",
  SET_COMPLEMENT_DATA_SELECTED_CITY: "SET_COMPLEMENT_DATA_SELECTED_CITY",
  SET_CLIENT: "SET_CLIENT",
  SET_RATE: "SET_RATE",
  SET_ESTRATO: "SET_ESTRATO",
  SET_EDAD: "SET_EDAD",
  SET_TIPO_CONTRATO: "SET_TIPO_CONTRATO",
  SET_PRODUCT: "SET_PRODUCT",
  SET_TASA: "SET_TASA",
  SET_ID_ASESOR: "SET_ID_ASESOR",
  SET_PAIS_NACIMIENTO: "SET_PAIS_NACIMIENTO",
  SET_SELECTED_CITY: "SET_SELECTED_CITY",
  SET_ACTIVITIE: "SET_ACTIVITIE",
  SET_PRICING: "SET_PRICING",
  SET_SELECT_ETHNIC_GROUP: "SET_SELECT_ETHNIC_GROUP",
  SET_SELECTED_GENDER: "SET_SELECTED_GENDER",
  SET_ACTIVITIE_CREDIT: "SET_ACTIVITIE_CREDIT",
  SET_BASIC_DATA_SPECIAL_CONDITION: "SET_BASIC_DATA_SPECIAL_CONDITION",
  SET_DESTINO_CREDITO: "SET_DESTINO_CREDITO",
}

export default types;
